/**
 * Pootafdruk met vier tenen (keuze 14), als eigen lijn-SVG: vier ovale
 * tenen boven een hielkussen. Geen emoji, geen icoonset.
 */
export function Pootafdruk({ maat = 30 }: { maat?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={maat}
      height={maat}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-testid="pootafdruk"
    >
      <ellipse cx="5.6" cy="9.2" rx="1.9" ry="2.5" transform="rotate(-18 5.6 9.2)" />
      <ellipse cx="9.6" cy="5.4" rx="1.9" ry="2.5" transform="rotate(-6 9.6 5.4)" />
      <ellipse cx="14.4" cy="5.4" rx="1.9" ry="2.5" transform="rotate(6 14.4 5.4)" />
      <ellipse cx="18.4" cy="9.2" rx="1.9" ry="2.5" transform="rotate(18 18.4 9.2)" />
      <path d="M12 11c3.1 0 5.5 2.4 6.1 5.1.5 2.3-1 4.4-3.3 4.4-1.2 0-1.9-.6-2.8-.6s-1.6.6-2.8.6c-2.3 0-3.8-2.1-3.3-4.4.6-2.7 3-5.1 6.1-5.1Z" />
    </svg>
  );
}
